export const styles = {
  container: {
    width: '100%',
    marginTop: '24px',
  },
  label: {
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '146%',
    marginBottom: '8px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
  },
};
